import Tab from '@mui/material/Tab';
import { tabStyle } from 'common/components/AppLayout/AppLayout.styles';
import { usePreviousPath } from 'common/components/AppLayout/AppNavigation/usePreviousPath';
import { Link, useParams } from 'react-router';
import { Routes } from 'src/Routes.constants';

import React from 'react';
import { useTranslation } from 'react-i18next';

import { TabsContainer } from 'src/common/components/AppLayout/Components/TabsContainer';
import { a11yTabProps } from 'src/common/components/AppLayout/Components/utils';
import { useHasFeatureFlag } from 'src/featureFlags/useHasFeatureFlag';

export const RSimDetailsTabsLayout = ({
  children,
  additionalTopMargin = 0,
}: {
  children: React.ReactNode;
  firstTabHighlited?: boolean;
  additionalTopMargin?: number;
}) => {
  const { t } = useTranslation();
  const { euicc } = useParams();
  const previousPath = usePreviousPath();

  const locationEnabled = useHasFeatureFlag('Locations');

  return (
    <TabsContainer content={children} additionalTopMargin={additionalTopMargin}>
      <Tab
        value={`${Routes.productsRsim}/${euicc}`}
        label={t('rSimInventory.details.tabs.general')}
        component={Link}
        to={`${Routes.productsRsim}/${euicc}`}
        state={{ previousPath }}
        sx={tabStyle}
        replace
        {...a11yTabProps(t('rSimInventory.details.tabs.general'))}
      />
      {locationEnabled ? (
        <Tab
          value={`${Routes.productsRsim}/${euicc}/location`}
          label={t('rSimInventory.details.tabs.location')}
          component={Link}
          to={`${Routes.productsRsim}/${euicc}/location`}
          state={{ previousPath }}
          sx={tabStyle}
          {...a11yTabProps(t('rSimInventory.details.tabs.location'))}
          replace
        />
      ) : null}
      <Tab
        value={`${Routes.productsRsim}/${euicc}/session-history`}
        label={t('rSimInventory.details.tabs.sessionHistory')}
        component={Link}
        to={`${Routes.productsRsim}/${euicc}/session-history`}
        state={{ previousPath }}
        sx={tabStyle}
        {...a11yTabProps(t('rSimInventory.details.tabs.sessionHistory'))}
        replace
      />
      <Tab
        value={`${Routes.productsRsim}/${euicc}/history-analysis`}
        label={t('rSimInventory.details.tabs.historyAnalysis')}
        component={Link}
        to={`${Routes.productsRsim}/${euicc}/history-analysis`}
        state={{ previousPath }}
        sx={tabStyle}
        {...a11yTabProps(t('rSimInventory.details.tabs.historyAnalysis'))}
        replace
      />
    </TabsContainer>
  );
};
